export default "__VITE_ASSET__D$hcw5zm__"